import { render, staticRenderFns } from "./AreaBasic.vue?vue&type=template&id=11f99f4f&scoped=true&"
import script from "./AreaBasic.vue?vue&type=script&lang=js&"
export * from "./AreaBasic.vue?vue&type=script&lang=js&"
import style0 from "./AreaBasic.vue?vue&type=style&index=0&id=11f99f4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f99f4f",
  null
  
)

export default component.exports